<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Recommended service providers</h1>
      <h2>
        Here is a list of our preferred partners. Please use the code word
        'UNIFI' when making your booking.
      </h2>
      <div
        v-if="list.length == 0"
        style="padding-top:80px;text-align:center;font-size:18px;color:#3F3F46;margin-bottom:218px"
      >
        No data.
      </div>
      <div v-for="(item, index) in list" v-else :key="index">
        <h3>{{ item.type }}</h3>
        <ul class="clear">
          <li v-for="(img, i) in item.houseProvidersPojoList" :key="i">
            <a
              :href="img.url"
              :style="{ backgroundImage: 'url(' + img.logoUrl + ')' }"
              class="img"
              target="_blank"
            ></a>
            <div class="tag">{{ img.tags }}</div>
          </li>
        </ul>
      </div>
    </div>
    <!--footer -->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      list: [],
      gray: true
    };
  },
  created() {
    var that = this;
    that.getLst({ params: that.$route.params.id, callback: that.callback });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("recommend", ["getLst"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          v.houseProvidersPojoList.forEach(i => {
            if (!i.tags) {
              return;
            }
            const a = i.tags.split(",");
            const b = a.join("、");
            i.tags = b;
          });
        });
        that.list = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 1.52rem 0.24rem 0 0.24rem;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
  }

  h2 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin-bottom: 0.8rem;
    color: #3f3f46;
    word-break: break-word;
  }

  h3 {
    font-size: 0.48rem;
    color: #333333;
    line-height: 0.58rem;
    position: relative;
    margin-bottom: 0.76rem;
  }

  h3:after {
    content: "";
    width: 1.16rem;
    height: 0.06rem;
    display: block;
    position: absolute;
    left: 0;
    bottom: -6px;
    background: #ffef00;
  }

  ul {
    margin-bottom: 0.96rem;

    li {
      // width:3.38rem;
      width: 48%;
      min-height: 3.04rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      float: left;
      margin-right: 0.25rem;
      box-sizing: border-box;
      position: relative;

      .img {
        display: block;
        width: 100%;
        height: 2.52rem;
        border: 1px solid rgba(223, 223, 223, 1);
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        cursor: pointer;
      }

      .tag {
        min-height: 0.36rem;
        padding-top: 0.16rem;
        font-size: 0.24rem;
        font-family: ProximaNova-Regular, ProximaNova;
        font-weight: 400;
        color: #858585;
        text-align: center;
        word-break: break-word;
      }
    }

    li:nth-child(even) {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/recommend.vue